import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
const FWP = window.FWP;

(function ($) {
  // Better always use a two digit format in your dates obj
  function twoDigitsDateFormat(val) {
    return ('0' + val).slice(-2);
  }

  FWP.logic = FWP.logic || {};

  /* ======== Support duplicate facets ======== */

  $('.facetwp-facet').each(function () {
    // jQuery doesn't support useCapture, so add the event listeners manually
    // useCapture handles outer elements first (unlike event bubbling)
    this.addEventListener(
      'click',
      function () {
        const $items = $('.facetwp-facet-' + $(this).data('name'));
        if (1 < $items.length) {
          $items.addClass('facetwp-ignore');
          $(this).removeClass('facetwp-ignore');
        }
        FWP.last_active_facet = $(this);
      },
      true
    );
  });

  FWP.hooks.addAction(
    'facetwp/refresh/date_picker',
    function ($this, facetName) {
      const min = $this.find('.facetwp-date-min').val() || '';
      const max = $this.find('.facetwp-date-max').val() || '';
      FWP.facets[facetName] = '' !== min || '' !== max ? [min, max] : [];
    }
  );

  FWP.hooks.addFilter(
    'facetwp/selections/date_picker',
    function (output, params) {
      const vals = params.selected_values;
      const $el = params.el;
      let out = '';

      if ('' !== vals[0]) {
        out += ' ' + ' ' + $el.find('.facetwp-date-min').next().val();
      }
      if ('' !== vals[1]) {
        out += ' ' + ' ' + $el.find('.facetwp-date-max').next().val();
      }
      return out;
    }
  );

  $(document).on('facetwp-loaded', function () {
    const $dates = $(
      '.facetwp-type-date_picker .facetwp-date:not(".ready, .flatpickr-alt")'
    );
    if (0 === $dates.length) {
      return;
    }

    const defaults = {
      dateFormat: 'Ymd',
      altInput: true,
      altInputClass: 'flatpickr-alt',
      altFormat: 'Ymd',
      disableMobile: true,
      locale: French,
      static: true,
      monthSelectorType: 'static',
      nextArrow: "<i class='icon icon-right-arrow'></i>",
      prevArrow: "<i class='icon icon-left-arrow'></i>",
      inline: true,
      onChange() {
        FWP.autoload();
      },
      onReady(dateObj, dateStr, instance) {
        const clearBtn = '<div class="flatpickr-clear">' + '</div>';
        $(clearBtn)
          .on('click', function () {
            instance.clear();
            instance.close();
          })
          .appendTo($(instance.calendarContainer));
      },
    };

    $dates.each(function () {
      const $this = $(this);
      const facetName = $this.closest('.facetwp-facet').attr('data-name');
      const settings = FWP.settings[facetName];
      const flatpickrOpts = defaults;

      flatpickrOpts.dateFormat = settings.format;
      flatpickrOpts.altFormat = settings.format;
      flatpickrOpts.static = settings.static || true;

      /* adding dots to days with events */
      flatpickrOpts.onDayCreate = function (dObj, dStr, fp, dayElem) {
        const currentDate =
          dayElem.dateObj.getFullYear() +
          twoDigitsDateFormat(dayElem.dateObj.getMonth() + 1) +
          twoDigitsDateFormat(dayElem.dateObj.getDate());
        const value = settings.busy_days[currentDate] || false;
        if (value) {
          dayElem.innerHTML += `<span class='event busy'>.</span>`;
        }
      };

      if ('both' === settings.fields) {
        const which = $this.hasClass('facetwp-date-min') ? 'min' : 'max';
        flatpickrOpts.minDate = settings.range[which].minDate;
        flatpickrOpts.maxDate = settings.range[which].maxDate;
      } else {
        flatpickrOpts.minDate = settings.range.minDate;
        flatpickrOpts.maxDate = settings.range.maxDate;
      }

      const opts = FWP.hooks.applyFilters(
        'facetwp/set_options/date_picker',
        flatpickrOpts,
        {
          facet_name: facetName,
          element: $this,
        }
      );
      new flatpickr(this, opts);
      $this.addClass('ready');
    });
  });

  $(function () {
    if ('undefined' !== typeof FWP) {
      $('.reset-filters').on('click', function () {
        FWP.reset('event_calendar');
      });
    }
  });
})(jQuery);
